import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TralalereService } from "src/app/services/tralalere.service";

/**
 * Barre d'onglets affichée uniquement hors production (voir app.component.html) :
 * en production, la navigation entre les pages est assurée par le LMS qui embarque
 * l'appli page par page, avec l'accesstoken en paramètre d'URL.
 */
@Component({
  selector: "app-dev-nav",
  templateUrl: "./dev-nav.component.html",
  styleUrls: ["./dev-nav.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
})
export class DevNavComponent {
  readonly tabs = [
    { path: "/suivi", label: "Suivi" },
    { path: "/resultats", label: "Résultats" },
    { path: "/assignation", label: "Assignations" },
    { path: "/recommandations", label: "Recommandations" },
    { path: "/assistant-enseignant", label: "Assistant enseignant" },
  ];

  constructor(public trala: TralalereService) {}

  get userLabel(): string {
    const user: any = this.trala.user;
    if (!user) {
      return "non connecté";
    }
    return user.label || user.email || user.id;
  }

  /**
   * Vide le token et le cache local puis recharge sans paramètre d'URL :
   * permet de retester le parcours "pas d'accesstoken" / page de login.
   */
  resetAuth() {
    this.trala.clearAuth();
    // rechargement complet, sans le paramètre accesstoken de l'URL courante.
    window.location.href = new URL("login", document.baseURI).href;
  }
}
